import { Form, Input, notification } from 'antd';
import storage from 'local-storage-fallback';
import React from 'react';

import { GIFT_CODE_ENCRYPTION_PASSWORD_KEY_PREFIX } from '@/App/constants';
import { useGacha } from '@/hooks/context/GachaContext';
import { useGiftCodeCrypto } from '@/hooks/context/GiftCodeCryptContext';
import { GiftCodeCrypto } from '@/service/giftCodeCrypto';

type FormValue = {
  password: string;
};

const CreateGiftCodeCryptoForm: React.FC<{}> = () => {
  const [form] = Form.useForm();
  const { setGiftCodeCrypto } = useGiftCodeCrypto();
  const { gacha } = useGacha();

  const onFinishPasswordInput = (values: FormValue): void => {
    const giftCodeCrypt = new GiftCodeCrypto(values.password);
    if (gacha.name !== giftCodeCrypt.decryptString(gacha.encryptName, gacha.iv)) {
      notification.error({
        message: 'パスワードに誤りがあります',
        description: '入力し直してもう一度お試しください',
      });
      form.resetFields();

      return;
    }

    setGiftCodeCrypto(giftCodeCrypt);

    const giftCodeCryptoPasswordKey = `${GIFT_CODE_ENCRYPTION_PASSWORD_KEY_PREFIX}${gacha.name}`;
    storage.setItem(giftCodeCryptoPasswordKey, values.password);
  };

  return (
    <div>
      <p>{gacha.name} のギフトコード暗号パスワードを入れてください</p>
      <Form form={form} onFinish={onFinishPasswordInput}>
        <Form.Item label="パスワード" name="password">
          <Input.Password />
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateGiftCodeCryptoForm;
